module.exports = __webpack_public_path__ + "static/media/HighGuardianOfAether09.d6659352.jpg";